// Mock data for EDITVERSE portfolio

export const featuredProjects = [
  {
    id: 1,
    title: "High Retention Based Edits",
    description: "Retention based storytelling",
    category: "Storytelling",
    beforeDescription: "Raw interview footage with multiple camera angles",
    afterDescription: "Polished emotional narrative with music and pacing",
    duration: "3:24",
    tags: ["Instagram", "Storytelling", "Color Grading"],
    videoUrl: "https://res.cloudinary.com/dntyusnxe/video/upload/v1/demo-reel_vtysba.mp4"
  },
  {
    id: 2,
    title: "Youtube ad style",
    description: "Storong positioning style",
    category: "YouTube Editing",
    beforeDescription: "Static product shots and unstructured footage",
    afterDescription: "Dynamic cuts with motion graphics and engaging pacing",
    duration: "1:45",
    tags: ["Youtube", "Product", "Fast Cuts"],
    videoUrl: "https://res.cloudinary.com/dntyusnxe/video/upload/v1/EVOCAA_YT_-_PORTFOLIO_2_jissfo.mp4"
  },
  {
    id: 3,
    title: "Social Media Reel",
    description: "Viral-style edit with perfect timing and audio sync",
    category: "Reels & Shorts",
    beforeDescription: "Raw B-roll footage without structure",
    afterDescription: "Perfectly timed cuts synced to trending audio",
    duration: "0:32",
    tags: ["Instagram", "Viral", "Audio Sync"],
    videoUrl: "https://res.cloudinary.com/dntyusnxe/video/upload/v1/SOLO_CREATOR_c0olhw.mp4"
  },
  {
    id: 4,
    title: "Documentary Style Edit",
    description: "Long-form content with compelling narrative flow",
    category: "Documentary",
    beforeDescription: "Hours of uncut interview and B-roll footage",
    afterDescription: "Structured story with seamless scene transitions",
    duration: "8:15",
    tags: ["Documentary", "Narrative", "Long-form"],
    videoUrl: "https://res.cloudinary.com/dntyusnxe/video/upload/v1/PORTFOLIO_-_evocaa_yt_ready_vh7clh.mp4"
  },
  {
    id: 5,
    title: "Contact for Similar Edits",
    description: "Let's transform your raw footage into compelling stories",
    category: "CTA",
    isCTA: true
  }
];

export const clientProjects = [
  {
    id: 1,
    title: "Social media reels",
    description: "Retention based storytelling",
    service: "Highenergy based for startup and buisness",
    videoUrl: "https://res.cloudinary.com/dt3ociot1/video/upload/v1782054832/Vd-06_Edited_nbgqvu.mp4"
  },
  {
    id: 2,
    title: "Ad creatives",
    description: "Ad for buisness",
    service: "Ad style reels",
    videoUrl: "https://res.cloudinary.com/dt3ociot1/video/upload/v1782030828/AD-02_Voiceover_Corrected_gvx7i7.mp4"

  },
  {
    id: 3,
    title: "Personal branding",
    description: "viral style for buisness and personal branding",
    service: "retention based edits",
    videoUrl: "https://res.cloudinary.com/dt3ociot1/video/upload/v1782054820/Vd-07_Edited_bragxw.mp4"
  },
  {
    id: 4,
    title: "Personal branding",
    description: "Clean storytelling for buisness",
    service: "Storytelling based edits",
    videoUrl: "https://res.cloudinary.com/dt3ociot1/video/upload/v1782031277/Vd_04_Corrected_Mp4_ceyzl4.mp4"
  },

  {
    id: 5,
    title: "Minimal & clean style",
    description: "Clean style for personal branding",
    service: "Instagram reels",
    videoUrl: "https://res.cloudinary.com/dt3ociot1/video/upload/v1782063550/Vd-03_Without_Number_wdzggg.mp4"
  },
  {
    id: 6,
    title: "Storytelling based shorts",
    description: "Storytelling based edit for buisness",
    service: "Youtube shorts",
    videoUrl: "https://res.cloudinary.com/dt3ociot1/video/upload/v1782063497/Vd-02_Without_Number_fkmalv.mp4"
  }
];

export const services = [
  {
    id: 1,
    title: "Retention-Focused Editing",
    description: "Data-driven pacing and structure designed to maximize average view duration and minimize drop-offs.",
    icon: "Zap"
  },
  {
    id: 2,
    title: "YouTube Growth Editing",
    description: "Long-form storytelling that turns casual viewers into subscribers through emotional connection.",
    icon: "Youtube"
  },
  {
    id: 3,
    title: "Viral Short-Form",
    description: "Hook-optimized Reels & Shorts engineered to stop the scroll and drive immediate engagement.",
    icon: "Smartphone"
  },
  {
    id: 4,
    title: "Visual Storytelling",
    description: "Transforming dry information into compelling narratives using b-roll, sound design, and motion.",
    icon: "Film"
  },
  {
    id: 5,
    title: "Sound Design & Mix",
    description: "Immersive audio atmospheres that keep viewers subconsciously engaged and focused.",
    icon: "Music"
  },
  {
    id: 6,
    title: "Premium Color Grading",
    description: "Cinematic looks that establish brand identity and perceived production value.",
    icon: "Palette"
  }
];

export const tools = [
  {
    id: 1,
    name: "Adobe Premiere Pro",
    category: "Primary Editor",
    logoUrl: "https://upload.wikimedia.org/wikipedia/commons/4/40/Adobe_Premiere_Pro_CC_icon.svg"
  },
  {
    id: 2,
    name: "After Effects",
    category: "Motion Graphics",
    logoUrl: "https://upload.wikimedia.org/wikipedia/commons/c/cb/Adobe_After_Effects_CC_icon.svg"
  },

  {
    id: 4,
    name: "DaVinci Resolve",
    category: "Color Grading",
    logoUrl: "https://upload.wikimedia.org/wikipedia/commons/4/4d/DaVinci_Resolve_Studio.png"
  },
  {
    id: 5,
    name: "Audition",
    category: "Audio Editing",
    logoUrl: "https://img.icons8.com/color/480/adobe-audition.png"
  },
  {
    id: 6,
    name: "Photoshop",
    category: "Thumbnails",
    logoUrl: "https://upload.wikimedia.org/wikipedia/commons/a/af/Adobe_Photoshop_CC_icon.svg"
  }
];

export const contactInfo = {
  phone: "7810044095",
  email: "contact.vibeeditors@gmail.com",
  linkedin: "https://www.linkedin.com/in/sanjai-innovator",
  instagram: "https://www.instagram.com/vibe__editors/",
  visuals: {
    phone: "https://img.icons8.com/3d-fluency/375/phone.png",
    email: "https://img.icons8.com/3d-fluency/375/mail.png",
    linkedin: "https://img.icons8.com/3d-fluency/375/linkedin.png",
    instagram: "https://img.icons8.com/3d-fluency/375/instagram-new.png"
  }
};